// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2AzUl","title":"FrontImage_title__32XQT"};